<template>
  <section>
    <Card :loading="loading.get">
      <template #header>
        <StepCardHeader
          v-model="current"
          :steps="steps"
          :onlyFirstAllowed="oRun.id ? false : true"
          returnRoute="/data/runs"
        />
      </template>
      <General-step v-if="current == 1" :run="oRun" @change="onChange" :loading="loading.get" />
      <Settings-step v-if="current == 2" :run="oRun" @change="onChange" />
      <DailyTimes-step v-if="current == 3" :run="oRun" @change="onChange" />
    </Card>
  </section>
</template>

<script>
import Card from '@/components/Card.vue';
import DailyTimesStep from './Steps/DailyTimes.vue';
import GeneralStep from './Steps/General/General.vue';
import SettingsStep from './Steps/Settings.vue';
import StepCardHeader from '@/components/StepCardHeader.vue';
import { Permissions } from '@/utils/Secure';
const { Runs } = Permissions;

export default {
  components: {
    Card,
    DailyTimesStep,
    GeneralStep,
    SettingsStep,
    StepCardHeader
  },
  async created() {
    if (this.paramsRunId) await this.getRun();
    if (!this.oRun.name) {
      this.$router.push('/data/runs/add');
    }
  },
  data() {
    const paramsRunId = Number(this.$route.params.runId || 0);
    return {
      paramsRunId,
      loading: { get: false, save: false },
      oRun: { id: paramsRunId },
      steps: [
        { name: 'global.general', permission: Runs.update },
        { name: 'global.settings', permission: Runs.update },
        { name: 'global.dailyTimes', permission: Runs.update }
      ],
      current: this.$route.meta?.current || 1
    };
  },
  computed: {},
  methods: {
    async getRun() {
      this.loading.get = true;
      try {
        const { data } = await this.Api.get(`driver_runs/${this.paramsRunId}`);
        this.oRun = data;
      } catch (error) {
        console.error(error);
      }
      this.loading.get = false;
    },
    onChangeStep(step = 1) {
      const routes = ['', '/settings', '/daily-times'];
      if (this.oRun.id) {
        this.$router.replace({
          path: `/data/runs/${this.oRun.id}${routes[step - 1]}`
        });
        this.current = step;
      }
    },
    onChange(run) {
      this.oRun = run;
    },
    goBack() {
      // TODO validate history to stay
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="sass" scoped>
.card
  margin: 0
  min-height: calc(100% - 90px)
  ::v-deep
    .card-header
      padding: 0
      justify-content: flex-end
</style>
